import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AddDependents } from '../../app/models/dependentDetails.model';
import { BehaviorSubject, filter, Observable, take } from 'rxjs';
import { API_BASE_URL } from './../environments/environments.module';

@Injectable({
  providedIn: 'root',
})

export class EmployeeInfoService {
  baseurl: any;

  private roles$ = new BehaviorSubject<string[] | null>(null);
  constructor(
    private httpClient: HttpClient,
    @Inject(API_BASE_URL) API_BASE_URL: any,
  ) {
    this.baseurl = API_BASE_URL.employeeInfo;
  }

  fetchRoles(eid: string) {
    const response =  this.httpClient
      .post<any>(this.baseurl + 'GetRole', {
        enterpriseId: eid,
      });

    return response;
  }


  getRoles(): Observable<string[]> {
    return this.roles$.asObservable().pipe(
      filter((r) => r !== null),
      take(1),
    );
  }

  getCachedRoles(): string[] | null {
    return this.roles$.value;
  }

  registerDependents(AddDependents: AddDependents) {
    return this.httpClient.post<any>(
      this.baseurl + 'AddDependents',
      AddDependents,
    );
  }
}
